import * as actionTypes from 'actions';

const initialState = {
  loading: false,
  analyses: []
};

// const PAGE = 'MODEL_COLLECTIONS_ANALYSIS';

const modelCollectionAnalysisReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.REMOVE_MODEL_WALK_COLLECTION_ANALYSIS_COMPARISON_ITEM_PENDING:
    case actionTypes.ADD_MODEL_WALK_COLLECTION_ANALYSIS_COMPARISON_ITEM_PENDING:
    case actionTypes.FIND_MODEL_WALK_COLLECTION_ANALYSIS_COMPARISONS_PENDING: {
      return {
        ...state,
        // analyses: initialState.analyses,
        loading: true
      };
    }

    case actionTypes.REMOVE_MODEL_WALK_COLLECTION_ANALYSIS_COMPARISON_ITEM_FULFILLED:
    case actionTypes.ADD_MODEL_WALK_COLLECTION_ANALYSIS_COMPARISON_ITEM_FULFILLED:
    case actionTypes.FIND_MODEL_WALK_COLLECTION_ANALYSIS_COMPARISONS_FULFILLED: {
      return {
        ...state,
        analyses: action.payload.data.result,
        loading: false
      };
    }

    default: {
      return state;
    }
  }
};

export default modelCollectionAnalysisReducer;
